(function(angular, module) {var TagManagerController, getTagSkip, sortOptions, tagManagerComponent,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

sortOptions = {
  participant: [
    {
      value: 'name',
      label: 'Name'
    }, {
      value: 'enrolled',
      label: 'Enrolled',
      desc: true
    }, {
      value: 'edited',
      label: 'Edited',
      desc: true
    }, {
      value: 'created',
      label: 'Created',
      desc: true
    }
  ],
  program: [
    {
      value: 'name',
      label: 'Name'
    }, {
      value: 'city',
      label: 'City'
    }, {
      value: 'id',
      label: 'Program Id'
    }
  ]
};

getTagSkip = function(tag, program) {
  if (tag.tag_for === 'participant' && (program != null)) {
    return 'program,location';
  } else if (tag.tag_for === 'program') {
    return 'participant';
  } else {
    return "";
  }
};

TagManagerController = (function() {

  /* @ngInject */
  function TagManagerController($scope, TagService) {
    this.changeBulk = bind(this.changeBulk, this);
    this.changeSingle = bind(this.changeSingle, this);
    this.getEntities = bind(this.getEntities, this);
    this.loadMore = bind(this.loadMore, this);
    this.refreshCounts = bind(this.refreshCounts, this);
    this.refresh = bind(this.refresh, this);
    this.TagService = TagService;
    this.entities = [];
    this.sortOptions = sortOptions[this.tag.tag_for];
    this.filters = {
      search: null,
      tags: {}
    };
    this.skip = getTagSkip(this.tag, this.program);
    this.noun = this.tag.tag_for + 's';
    this.Noun = this.tag.tag_for[0].toUpperCase() + this.tag.tag_for.slice(1) + 's';
    this.sort = "name";
    $scope.$watch(((function(_this) {
      return function() {
        return _this.filters;
      };
    })(this)), ((function(_this) {
      return function() {
        return _this.refresh(true);
      };
    })(this)), true);
    this.onlyTag = true;
    this.onlyTagOptions = [
      {
        value: false,
        name: 'All ' + this.noun
      }, {
        value: true,
        name: 'In Tag'
      }
    ];
    $scope.$on('TagNotification.displayed', this.refreshCounts);
  }

  Object.defineProperties(TagManagerController.prototype, {
    showBulkAdd: {
      get: function() {
        var ref;
        return (!this.onlyTag) && this.hasFilter && ((ref = this.counts) != null ? ref["false"] : void 0) > 0;
      }
    },
    showBulkRemove: {
      get: function() {
        var ref;
        return this.onlyTag && ((ref = this.counts) != null ? ref["true"] : void 0) > 0;
      }
    },
    showDeleteTag: {
      get: function() {
        var ref;
        return ((ref = this.counts) != null ? ref["true"] : void 0) === 0 && this.onlyTag && !this.hasFilter;
      }
    },
    allowRedirect: {
      get: function() {
        return this.onlyTag && this.counts["true"] === 0 && this.counts["false"] > 0 && this.tag.editable;
      }
    }
  });

  TagManagerController.prototype.refresh = function(redirect) {
    var ref;
    this.hasFilter = Object.keys(this.filters.tags).length > 0 || ((ref = this.filters.search) != null ? ref.length : void 0) > 0;
    return this.getEntities({
      sort: this.sort,
      limit: 10
    }).then((function(_this) {
      return function(response) {
        _this.entities = response.data.items;
        _this.totalCount = response.data.count;
        _this.counts = response.data.counts;
        if (_this.allowRedirect && redirect) {
          _this.onlyTag = false;
          return _this.refresh();
        }
      };
    })(this));
  };

  TagManagerController.prototype.refreshCounts = function(extra) {
    var params;
    params = this.getQueryParams(extra);
    return this.TagService.getEntityCount(this.tag, params).then((function(_this) {
      return function(counts) {
        _this.counts = counts;
        _this.totalCount = counts[_this.onlyTag];
      };
    })(this));
  };

  TagManagerController.prototype.loadMore = function() {
    var last;
    last = this.entities[this.entities.length - 1].id;
    return this.getEntities({
      limit: 10,
      after: last,
      sort: this.sort
    }).then((function(_this) {
      return function(response) {
        var ref;
        (ref = _this.entities).push.apply(ref, response.data.items);
      };
    })(this));
  };

  TagManagerController.prototype.getQueryParams = function(extra) {
    var params;
    if (extra == null) {
      extra = {};
    }
    params = angular.copy(this.filters.tags);
    params.q = this.filters.search;
    params.only_tagged = this.onlyTag;
    angular.extend(params, extra);
    return params;
  };

  TagManagerController.prototype.getEntities = function(extra) {
    var params;
    if (extra == null) {
      extra = {};
    }
    params = this.getQueryParams(extra);
    return this.TagService.getEntities(this.tag, params);
  };

  TagManagerController.prototype.changeSingle = function(entity) {
    if (!this.tag.editable) {
      return;
    }
    return this.TagService.setEntityTag(this.tag, entity, !entity.has_tag).then(function() {
      return entity.has_tag = !entity.has_tag;
    });
  };

  TagManagerController.prototype.changeBulk = function(remove) {
    var filters, method;
    if (!this.tag.editable) {
      return;
    }
    filters = angular.copy(this.filters.tags);
    filters.q = this.filters.search;
    method = remove ? this.TagService.untagFiltered : this.TagService.tagFiltered;
    return method(this.tag, filters).then(this.refresh);
  };

  TagManagerController.prototype["delete"] = function() {
    return this.TagService["delete"](this.tag).then((function(_this) {
      return function() {
        return _this.onDelete({
          tag: _this.tag
        });
      };
    })(this));
  };

  return TagManagerController;

})();

tagManagerComponent = {
  controller: TagManagerController,
  controllerAs: 'tagManager',
  templateUrl: 'tags/tagManager',
  bindings: {
    tag: '=',
    onDelete: '&',
    program: '='
  }
};

module.component('tagManager', tagManagerComponent);
})(angular, angular.module("dybTags"));